import React from 'react';
import PropTypes from 'prop-types';
import Classes from '../common/Classes';
import { FavouriteConstants } from '../common/Constants';

const FavouriteIcon = ({ isFavourited, altSVG }) => (
  <svg
    data-testid="Favourite-icon"
    width="21px"
    height="25px"
    viewBox="0 0 25 23"
    aria-labelledby="uniqueDescID"
    role="img"
    className={Classes.favouriteIconImg}
  >
    <desc id="uniqueDescID">{altSVG}</desc>
    {isFavourited
      ? (
        <g>
          <path className={Classes.favSelectFill} d={FavouriteConstants.favouriteIconUnSelectedPath2} />
        </g>
      )
      : (
        <g>
          <path className={Classes.favSelectFill} d={FavouriteConstants.favouriteIconUnSelectedPath1} />
        </g>
      )}
  </svg>
);

FavouriteIcon.propTypes = {
  isFavourited: PropTypes.bool.isRequired,
  altSVG: PropTypes.string.isRequired
};

export default FavouriteIcon;
